<template>
    <!-- 应收调整列表 -->
    <vReceivableAdjustmentList :postList="postList" v-if="flag"></vReceivableAdjustmentList>
</template>
<script>
import vReceivableAdjustmentList from '../../listComponent/basicdata/receivableAdjustment/receivableAdjustmentComponent.vue';
export default {
    name: 'receivableAdjustmentList',
    components: {
        vReceivableAdjustmentList
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>